import axios from 'axios';

const baseURL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4018/api';

const client = axios.create({ baseURL });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('pmp_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401) {
      // Session expired / invalid — clear and let ProtectedRoute redirect.
      const onAuthPage = /\/(login|register|verify|mfa|forgot|reset)/.test(window.location.pathname);
      if (!onAuthPage) {
        localStorage.removeItem('pmp_token');
        localStorage.removeItem('pmp_user');
      }
    }
    return Promise.reject(err);
  }
);

export function apiError(err, fallback = 'Something went wrong.') {
  return (err && err.response && err.response.data && err.response.data.error) || fallback;
}

export default client;
